import React, { FC, useContext, useEffect } from 'react'
import { TabContext } from 'src/components/extend/Tab/components/TabContext'

type TProps = {
  children: React.ReactNode
  onChangeTab: (val: any) => void
}

export const TabContentWrapper: FC<TProps> = ({ onChangeTab, children }) => {
  const { currentTab } = useContext(TabContext)

  useEffect(() => {
    onChangeTab(currentTab)
  }, [currentTab]) // eslint-disable-line

  return <>{children}</>
}
